"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.pendingSecretErrorCode_10 = exports.approvalRequiredErrorCode_11 = exports.classes = exports.adminSecretListConstants = exports.editString = exports.addString = void 0;
var addString = 'add';
exports.addString = addString;
var editString = 'edit';
exports.editString = editString;
var adminSecretListConstants = {
  priVariant: 'primary',
  secVariant: 'secondary',
  largeSize: 'large',
  maxJustificationChars: '255',
  mediumSize: 'medium',
  pendingSecretErrorCode_10: 'PE-0010'
};
exports.adminSecretListConstants = adminSecretListConstants;
var classes = {
  secretApprovalLayout: 'secret-approval-widget-layout',
  secretApprovalSpacing: 'secret-approval-widget-spacing',
  secretApprovalLabel: 'secret-approval-widget-label'
};
exports.classes = classes;
var approvalRequiredErrorCode_11 = 'PE-0011';
exports.approvalRequiredErrorCode_11 = approvalRequiredErrorCode_11;
var pendingSecretErrorCode_10 = 'PE-0010';
exports.pendingSecretErrorCode_10 = pendingSecretErrorCode_10;